import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
  Button,
  Chip
} from '@mui/material';
import { FiX, FiEdit2 } from 'react-icons/fi';
import { AccountDetailsDrawerProps, Account } from '../../../types/accounting';

export const AccountDetailsDrawer: React.FC<AccountDetailsDrawerProps> = ({
  account,
  open,
  onClose,
  onUpdate,
  showTaxCategories = false,
  showFundTypes = false,
  showRestrictions = false
}) => {
  const handleUpdate = async (data: Partial<Account>) => {
    if (account) {
      await onUpdate(account.id, data);
    }
  };

  if (!account) return null;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 400, p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Account Details</Typography>
          <IconButton onClick={onClose}>
            <FiX />
          </IconButton>
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        <List>
          <ListItem>
            <ListItemText 
              primary="Account Code" 
              secondary={account.code}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Account Name" 
              secondary={account.name}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Account Type" 
              secondary={account.type}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Normal Balance" 
              secondary={account.normalBalance}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Status" 
              secondary={
                <Chip 
                  label={account.status} 
                  color={account.status === 'active' ? 'success' : 'default'}
                  size="small"
                />
              }
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Description" 
              secondary={account.description || 'No description provided'}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          </ListItem>
        </List>

        <Box mt={3}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<FiEdit2 />}
            onClick={() => {
              // Implement edit logic
            }}
          >
            Edit Account
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}; 